import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";

const MealOptions = ({ foodData,meal_package_non_veg_adult_price,meal_package_non_veg_child_price,meal_package_veg_adult_price,meal_package_veg_child_price }) => {
  const { points, images } = foodData;
  const [open, setOpen] = useState(false);

  return (
    <div className="flex justify-center font-sans font-Glory mb-12">
      <div className="flex flex-col py-4 px-8 lg:mx-auto  flex-wrap text-[16px] text-black  w-[90vw] bg-[#f1f1f1]  border-[1px] rounded-lg shadow-lg ">
        <h1 className="font-semibold mb-2">
          There are following meal options for your stay :
        </h1>
        <ul className="text-[14px]">
          {points[0] && (
            <li className="list-disc">The guest can cook by Himself</li>
          )}
          {points[1] != 0 && (
            <li className="list-disc">
              The guest can hire a cook from the property at Rs {points[1]} per
              day. Groceries charges are extra
            </li>
          )}
          {points[2] && (
            <li className="list-disc">
              The guest can Select Veg/NonVeg Food package
            </li>
          )}
          {points[3] && (
            <li className="list-disc">
              The guest can order from nearby restaurants or can Zomato, Swiggy.{" "}
            </li>
          )}
        </ul>
        <div className="flex flex-wrap flex-row my-4">
          <div className="relative">
            <img
              className="object-cover h-48 w-40 ml-4 mb-2 mt-1 lg:mb-0 rounded-sm"
              src={images[0].src}
              alt="image"
            />
          </div>
          <div className="flex flex-row items-center ">
            <div className="relative">
              <img
                className="object-cover h-48 w-40 ml-4 mb-2 lg:mb-0 rounded-sm"
                src={images[1].src}
                alt="image"
              />

              <div className="absolute ml-4 mb-2 lg:mb-0 inset-0 flex items-center justify-center">
                <button
                  onClick={() => setOpen(true)}
                  className="bg-black bg-opacity-50 text-white px-4 py-2 h-48 w-full rounded-sm"
                >
                  <span className="opacity-100">View All</span>
                </button>
              </div>
            </div>

            <div className="ml-[220px]">
              <div className="flex flex-row my-2">
                <img src="/veg.svg" className="scale-[0.85]" />
                <div className="ml-4">
                  <h1 className="text-[14px] font-semibold">VEG</h1>
                 {meal_package_veg_adult_price?( <h2 className="">Adult : Rs.{meal_package_veg_adult_price} per head</h2>):(<h2>Adult : N/A</h2>)}
                 {meal_package_veg_adult_price?( <h2 className="">Children : Rs.{meal_package_veg_child_price} per head</h2>):(<h2>Children : N/A</h2>)}
                </div>
              </div>
              <div className="flex flex-row">
                <img src="/non-veg.svg" className="scale-[0.9] ml-2" />
                <div className="ml-4">
                  <h1 className="text-[14px] font-semibold">NON-VEG</h1>
                  {meal_package_veg_adult_price?( <h2 className="">Adult : Rs.{meal_package_veg_adult_price} per head</h2>):(<h2>Adult : N/A</h2>)}
                 {meal_package_veg_adult_price?( <h2 className="">Children : Rs.{meal_package_veg_child_price} per head</h2>):(<h2>Children : N/A</h2>)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={images}
          plugins={[Thumbnails]}
        />
      </div>
    </div>
  );
};

export default MealOptions;
